//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      visible: false,
      enterIn: null,
      freeTry: null
    }
  },
  methods: {
    showConfirm (enterIn, freeTry) {
      this.enterIn = enterIn
      this.freeTry = freeTry
      this.visible = true
    },
    handleEnterIn () {
      if (this.enterIn) {
        this.enterIn()
      }
      this.handleCancel()
    },
    handleContinue () {
      if (this.freeTry) {
        this.freeTry()
      }
      this.handleCancel()
    },
    handleCancel () {
      this.visible = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/modules/userBindConfirm.vue